import { newsItem } from '../../../schema';
import { denormalize } from 'normalizr';

export const selectHydrated = (state, id) => denormalize(id, newsItem, state.entities);



// WEBPACK FOOTER //
// ./src/redux/modules/news/selectors.js